import React, { useEffect, useState } from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Table, Empty, Form, Divider, Button, message, Skeleton, DatePicker, Card, Space } from 'antd';
import FormBodyDay from './form';
import { getByDate } from '../../../../apis/ChecadaDiaApi';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

dayjs.locale('es');

const routes = [
    {
        href: '',
        title: <>
            <HomeOutlined />
            <span>Inicio</span>
        </>,
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Asistencia</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Empleados</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <CheckCircleOutlined />
                <span>Checadas por Día</span>
            </>
        ),
    }
];

const CheckInsByDayPage = () => {
    const [form] = Form.useForm();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fechaSeleccionada, setFechaSeleccionada] = useState(dayjs());
    const [mostrarTabla, setMostrarTabla] = useState(false);

    const columns = [
        {
            title: 'Día',
            dataIndex: 'tipo_dia_texto',
            key: 'tipo_dia_texto',
            width: 120,
            fixed: 'left',
        },
        {
            title: 'Empleado',
            dataIndex: 'empleado_nombre',
            key: 'empleado_nombre',
            width: 250,
            fixed: 'left',
        },
        {
            title: 'Entrada',
            dataIndex: 'entrada',
            key: 'entrada',
            width: 150,
            render: (value) => value ? dayjs(value).format('HH:mm') : ''
        },
        {
            title: 'Salida',
            dataIndex: 'salida',
            key: 'salida',
            width: 150,
            render: (value) => value ? dayjs(value).format('HH:mm') : ''
        },
        {
            title: 'Horas Trabajadas',
            dataIndex: 'horas_trabajadas',
            key: 'horas_trabajadas',
            width: 150,
            render: (value) => value || 0
        },
        {
            title: 'Horas Extra',
            dataIndex: 'horas_extra',
            key: 'horas_extra',
            width: 120,
            render: (value) => value || 0
        },
        {
            title: 'Descanso',
            dataIndex: 'descanso',
            key: 'descanso',
            width: 100,
            render: (value) => value || 0
        },
        {
            title: 'Festivo',
            dataIndex: 'festivo',
            key: 'festivo',
            width: 100,
            render: (value) => value || 0
        },
        {
            title: 'Horas Autorizadas',
            dataIndex: 'horas_autorizadas',
            key: 'horas_autorizadas',
            width: 150,
            render: (value) => value || 0
        },
        // {
        //     title: 'Estación',
        //     dataIndex: 'estacion_id',
        //     key: 'estacion_id',
        //     width: 150,
        //     render: (value) => value ? `Estación ${value}` : ''
        // },
        {
            title: 'Horario',
            dataIndex: 'horario_nombre',
            key: 'horario_nombre',
            width: 200,
        },
        // {
        //     title: 'Usuario que importó',
        //     dataIndex: 'usuario_creo',
        //     key: 'usuario_creo',
        //     width: 180,
        // },
        // {
        //     title: 'Fecha y hora de Importación',
        //     dataIndex: 'fecha_importacion',
        //     key: 'fecha_importacion',
        //     width: 200,
        //     render: (value) => value ? dayjs(value).format('DD/MM/YYYY HH:mm') : ''
        // },
        {
            title: 'Referencia',
            dataIndex: 'referencia',
            key: 'referencia',
            width: 150,
        },
    ];

    const handleMostrar = async () => {
        if (!fechaSeleccionada) {
            message.warning('Por favor selecciona una fecha');
            return;
        }

        setLoading(true);
        setMostrarTabla(true);

        try {
            const fechaFormato = fechaSeleccionada.format('YYYY-MM-DD');
            
            // Obtener datos del usuario del localStorage
            const currentUserStr = localStorage.getItem('currentUser');
            let isSupervisor = false;
            let supervisorId = null;
            
            if (currentUserStr && currentUserStr !== 'undefined') {
                try {
                    const currentUser = JSON.parse(currentUserStr);
                    isSupervisor = currentUser.is_supervisor || false;
                    supervisorId = currentUser.supervisor_id || null;
                } catch (error) {
                    console.error('Error parsing currentUser from localStorage:', error);
                    localStorage.removeItem('currentUser');
                }
            }
            
            console.log('Usuario actual - is_supervisor:', isSupervisor, 'supervisor_id:', supervisorId);
            
            const response = await getByDate(fechaFormato, isSupervisor, supervisorId);

            if (response.ok) {
                const dataFormateada = response.payload.map((item, index) => ({
                    key: index,
                    id: item.id,
                    fecha: item.fecha,
                    tipo_dia: item.tipo_dia,
                    tipo_dia_texto: item.tipo_dia_texto,
                    empleado_id: item.empleado_id,
                    empleado_nombre: item.empleado_nombre,
                    entrada: item.entrada ? dayjs(item.entrada).format('HH:mm') : '',
                    salida: item.salida ? dayjs(item.salida).format('HH:mm') : '',
                    horas_trabajadas: item.horas_trabajadas || 0,
                    horas_extra: item.horas_extra || 0,
                    descanso: item.descanso || 0,
                    festivo: item.festivo || 0,
                    horas_autorizadas: item.horas_autorizadas || 0,
                    estacion_id: item.estacion_id,
                    horario_id: item.horario_id,
                    horario_nombre: item.horario_nombre || '',
                    usuario_creo: item.usuario_creo || '',
                    fecha_importacion: item.fecha_importacion,
                    referencia: item.referencia || '',
                    retardo: item.retardo || 0,
                    asistencia: item.asistencia || 0,
                }));

                setItems(dataFormateada);
                message.success(`Se cargaron ${dataFormateada.length} empleados para el ${fechaSeleccionada.format('DD/MM/YYYY')}`);
            } else {
                message.error('Error al cargar los datos');
            }

        } catch (error) {
            console.error('Error al cargar datos:', error);
            message.error('Error al cargar los datos');
        } finally {
            setLoading(false);
        }
    }

    const onChangeFecha = (date) => {
        setFechaSeleccionada(date);
        setMostrarTabla(false);
        setItems([]);
    }

    return <PageApp
        routes={routes}
        title={'Checadas por Día'}>
        <>
            <Card size="small" style={{ marginBottom: 16 }}>
                <Space size="middle" align="center">
                    <Form.Item 
                        label="Fecha" 
                        style={{ marginBottom: 0 }}
                    >
                        <DatePicker
                            value={fechaSeleccionada}
                            onChange={onChangeFecha}
                            format="DD/MM/YYYY"
                            placeholder="Selecciona una fecha"
                            style={{ width: 200 }}
                        />
                    </Form.Item>
                    
                    <Button 
                        type="primary" 
                        onClick={handleMostrar}
                        loading={loading}
                    >
                        Mostrar
                    </Button>
                </Space>
            </Card>

            <Divider />
        </>

        {
            loading ? (
                <Skeleton loading={loading} active />
            ) : (
                <>
                    {
                        !mostrarTabla || items.length === 0 ? (
                            <Empty description="Selecciona una fecha y presiona 'Mostrar' para ver los registros" />
                        ) : (
                            <FormBodyDay
                                items={items}
                                setItems={setItems}
                                columns={columns}
                                fecha={fechaSeleccionada}
                            />
                        )
                    }
                </>
            )
        }
    </PageApp>
}

export default CheckInsByDayPage;